<template>
    <div class="main-search index-container">
        <div class="nav-header">
            <van-nav-bar title="搜索" left-arrow @click-left="leftFn" />
        </div>
        <div class="search-container-warp">
            <!-- 搜索框 -->
            <div class="search-wrap">
                <common-search ref="searchCom" @focusEvent="focusEventFn" @searchEvent="searchFn" />
            </div>

            <!-- 推荐标签区 -->
            <recommod-serch v-if="showHistory"></recommod-serch>

            <!-- 历史搜索区 -->
            <div class="part-history">
                <history-search
                    ref="historyRef"
                    :inputKeyValue="inputKeyValues"
                    @historyItem="historyItemSearch"
                    @removeAll="delHistory"
                    :showHistory="showHistory"
                />
            </div>
            <!-- 无数据展示 -->
            <div class="nodata" v-show="showSearchNodata">
                <search-nodata :searchContent="inputKey" :showSearchNodata="showSearchNodata" />
            </div>
            <!-- 网络断了 -->
            <div class="part_neterror" v-if="showNetErr">
                <search-error style="padding-top:200px" :showNetErr="showNetErr" />
            </div>
            <!-- 搜索展示区 -->
            <div class="part_content">
                <van-list
                    v-show="showSearchContent"
                    ref="listContent"
                    :immediate-check="false"
                    v-model="loading"
                    :finished="finished"
                    finished-text="已加载完全部数据"
                    @load="loadMore"
                >
                    <second-step
                        :showVideoPng="showVideoPng"
                        :contentList="searchList"
                        :showContent="showSearchContent"
                    />
                </van-list>
            </div>
            <div class="skelong_container" v-if="loadingStatus">
                <skeleton-search v-for="(item,index) in 2" :key="index" />
            </div>
        </div>
        <div class="loading_area">
            <loading v-if="loadingStatus"></loading>
        </div>
    </div>
</template>

<script>


import HistorySearch from '../../components/parent-course/history-search.vue';
import CommonSearch from '../../components/parent-course/common-search.vue';
import SearchNodata from '@/components/parent-course/search-nodata.vue';
import SearchError from '../../components/parent-course/search-error.vue';
import SecondStep from '@/components/parent-course/second-step'
import { _getCourseList, _saveSearchHistory } from '../../api/parent-course'
import { Toast } from 'vant';
import { verticalScreen } from '../../assets/js/vertical-screen';
import Loading from '@/components/common/is-loading'
import { format } from 'echarts';
import SkeletonSearch from '../../components/common/skeleton-search.vue';
import RecommodSerch from '../../components/parent-course/recommod-serch.vue';
export default {
    name: 'search',
    components: { SecondStep, CommonSearch, HistorySearch, SearchError, SearchNodata, Loading, SkeletonSearch, RecommodSerch },
    props: {

    
        },
    data() {
        return {
            focusFlag: false,
            loadingStatus: false,
            inputKeyValues: '',
            inputKey: '',//输入的关键词
            loading: false,
            finished: false,
            showSearchContent: true,//list列表展示
            showVideoPng: false,
            showNetErr: false,//网络异常的搜索
            searchContentDeatil: '萝莉1',//展示搜索内容
            showSearchNodata: false,//展示搜索无数据状态
            showHistory: false,//展示历史搜索
            showContent: false,//展示搜索后出现的文章视频列表
            searchValue: '',
            searchContent: '剑豪',//搜索的关键词
            searchList: [],
            searchParams: {
                asc: false,
                currentPage: 0,
                // orderByField: 'createTime',
                pageSize: 5,//每页多少条
                queryData: {
                    // tag: '', to do: 区分儿童和家长的搜索
                    contentTypeList: ['VIDEO', 'PICTURE'],
                    searchContent: '',//查询的关键字
                }
            },
        };
    },
    //   watch: {
    //     $route: {
    //       handler(cur, pre) {
    //         let cPath = cur.path;
    //         let pPath = pre.path;
    //       },
    //       deep:true
    //     }
    //   },
    computed: {},
    methods: {
        leftFn() {
            this.$router.back()
            localStorage.removeItem('keyWord')
        },
        focusEventFn() {
            // 隐藏骨架图
            this.loadingStatus = false
            // 隐藏搜索内容
            this.showSearchContent = false
            // 显示历史搜索区
            // this.showHistory = true
            // 不显示无数据状态
            this.showSearchNodata = false
            // 获取历史数据
            this.$refs.historyRef.getSearchHistory()
        },
        //清空历史数据
        delHistory() {
            this.showHistory = false
        },
        // 历史关键词搜索
        historyItemSearch(item) {
            this.showHistory = false
            this.inputKeyValues = item.history
            // 更新关键词
            this.$storage.setStore('keyWord', item.history)
            this.$bus.$emit('handleItem', item.history)
            // 发请求查数据
            // 重置数据
            this.searchList = []
            //执行搜索请求，获取数据
            this.searchParams.queryData.searchContent = item.history
            this.searchParams.currentPage = 0
            this.inputKey = item.history
            if (this.inputKey.length > 10) {
                this.inputKey = this.inputKey.substr(0, 10) + '...'
            }
            this.loadMore()
        },
        searchFn(val) {
            this.showHistory = false
            if (!val) {
                this.$refs.historyRef.getSearchHistory()
            }
            if (!val) {
                Toast('请先输入关键词')
                this.$refs.searchCom.focusFn()
                return
            }
            // 存款关键词
            this.$storage.setStore('keyWord', val)
            // 重置数据
            this.searchList = []
            //执行搜索请求，获取数据
            this.searchParams.queryData.searchContent = val
            this.searchParams.currentPage = 0
            this.inputKey = val
            if (this.inputKey.length > 10) {
                this.inputKey = this.inputKey.substr(0, 10) + '...'
            }
            this.loadMore()
        },

        // 查询搜索内容，区别于首页获取数据的地方在于传参
        async getCourseList(searchParams) {
            this.loadingStatus = true
            try {
                let res = await _getCourseList(searchParams)
                this.loadingStatus = false
                let { code, data, message } = res
                if (res && code === 200) {
                    this.showNetErr = false
                    // if(data.records.length === 0) {
                    //     this.showSearchNodata = true
                    //     this.showSearchContent = false
                    //     this.searchList = []
                    // }
                    //加载状态结束
                    this.loading = false
                    // 合并第一次和第N次请求的书
                    this.searchList = this.searchList.concat(data.records)
                    if (this.searchList.length === 0) {
                        this.showSearchNodata = true
                        this.showSearchContent = false
                        this.searchList = []
                        // 数据没出来，也不显示历史搜索
                        this.showHistory = false
                        this.$storage.removeStore('keyWord')
                    } else {
                        this.showSearchNodata = false
                        this.showSearchContent = true
                        // 数据出来，不显示历史搜索
                        this.showHistory = false
                    }
                    //当数据全部加载完成
                    if (data.records.length == 0) {
                        this.finished = true
                    }
                } else {
                    this.$refs.searchCom.focusFn()
                    this.showNetErr = true
                    this.searchList = []
                    this.loading = false
                    // this.error = true
                    // this.showemptyData = true
                    Toast(message)
                }
            } catch (error) {
                
            }
        },
        loadMore() {
            let { searchParams } = this
            searchParams.currentPage += 1
            this.getCourseList(searchParams)
        },
        // 收到子组件中搜索历史关键词为空，就赋值不显示
        inF() {
            this.$bus.$on('showF', (item) => {
                this.showHistory = item
            })
        }
    },
    beforeCreate() { },
    created() {
        this.inF()
        // 判断有无之前搜索的东西，有的话再次呈现
        let key = localStorage.getItem('keyWord')
        if (key) {
            this.searchFn(key)
        }
    },
    beforeMount() { },
    mounted() {
        let focusFlga = JSON.parse(sessionStorage.getItem('flagFocus'))
        // 初次进入页面，触发历史数据的数据调用
        if (focusFlga) {
            this.$refs.searchCom.focusFn();
        }
        verticalScreen();
    },
    // 如果从搜索进入到文章或者视频的详情，从详情中退出来，不触发input的focus事件
    beforeRouteEnter(to, from, next) {
        if (from.path == '/artical' || from.path == '/video') {
            sessionStorage.setItem('flagFocus', false)
        } else {
            sessionStorage.setItem('flagFocus', true)
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        this.$bus.$off('showF');
        next();
    },
    activated() { },
    deactivated() { },
    beforeDestroy() { },
    destroyed() { },
};
</script>

<style lang="scss" scoped>
.main-search {
    padding-top: 0;
    .nav-header {
        position: fixed;
        width: 100%;
        z-index: 99;
        font-size: 18px;
        font-weight: 500;
        ::v-deep .van-icon {
            font-size: 18px;
        }
    }
    .search-container-warp {
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .search-wrap { 
            position: fixed;
            padding: 14px 20px 12px 20px;
            width: 100%;
            top: 45px;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 99;
            background: url('../../assets/images/index/header-bg.png') no-repeat;
            background-size: 100%;
            background-position-y: -130px;
            background-color: #F5F7FA;

        }
        .nodata {
            margin-top: 168px;
        }
        .part_content {
            padding-top: 112px;
            .van-list {
                ::v-deep .van-list__finished-text {
                    line-height: 69px;
                }
                ::v-deep .van-list__loading {
                    line-height: 69px;
                }
            }
        }
        .skelong_container {
            padding-top: 45px;
        }
        .part_neterror {
            // padding-top: 200px;
        }
        .part-history {
            // padding-top: 80px;
        }
    }
    .loading_area {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
